import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserManagementComponent } from '@pg-app/client/user-management/containers/user-management.component';
import { UserManagementGuard } from '@pg-app/client/user-management/user-management.guard';

const routes: Routes = [
    {
        path: '',
        component: UserManagementComponent,
        canActivate: [UserManagementGuard],
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UserManagementRoutingModule { }